import { useLayoutEffect } from "react";
function useScrollToSelectedItem(state, popper) {
  const { open, dropdownSelectedIndex, error, dropdownOptions } = state;
  useLayoutEffect(() => {
    if (popper === null) return;
    if (!open) return;
    if (dropdownSelectedIndex === -1) return;
    if (error) return;
    const selectedElement = popper.querySelector(
      `[data-int-value="${dropdownOptions[dropdownSelectedIndex].value}"]`
    );
    if (!selectedElement) return;
    selectedElement.scrollIntoView({ block: "start" });
  }, [popper, dropdownSelectedIndex, open, error, dropdownOptions]);
}
export {
  useScrollToSelectedItem
};
//# sourceMappingURL=useScrollToSelectedItem.js.map
